import { useState, useEffect } from "react"
import { Container } from "@mui/system"
import { Box, CssBaseline, Grid } from "@mui/material"
import DynamicDataGrid from '../components/DynamicDataGrid';
import NavAppBar from "../components/NavAppBar"
import { useAuth } from "../context/AuthProvider"
import dataService from '../services/Data'

export const Usuarios = () => {
    const { user } = useAuth()
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [error, setError] = useState("");
    const [mostrarError, setMostrarmostrarError] = useState(false)
    const [isMobile, setMobile] = useState(false);
    const [loading, setLoading] = useState(true);
    const [rowsRol, setRowsRol] = useState([]);
    let columnData = null;

    //{ field: 'empresa', headerName: 'EMPRESA', width: 120, align: 'left', editable: false, value: "", hide: true }];

    dataService.setToken(user.data.token)

    useEffect(() => {
        try {
            setLoading(true);
            setMobile(window.innerWidth < 740 ? true : false)
            dataService.listarUsuarios(setRows, true);
            dataService.listarRoles(setRowsRol, true);
        } catch (err) {
            setError('Error al cargar los datos');
            setMostrarmostrarError(true);
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        (() => {
            columnData = [{ field: 'usuarioID', headerName: 'ID', width: 50, align: 'center', editable: false },
            //{ field: 'clienteID', headerName: 'ClienteID', width: 90, align: 'left', editable: false },
            { field: 'nombre', headerName: 'NOMBRE', width: 140, align: 'left', editable: true, required: true },
            { field: 'apellido', headerName: 'APELLIDO', width: 140, align: 'left', editable: true, required: true },
            { field: 'dni', headerName: 'DNI', width: 90, align: 'center', editable: true, required: true },
            { field: 'celular', headerName: 'CELULAR', width: 105, align: 'center', editable: true, required: true },
            { field: 'email', headerName: 'MAIL', width: 255, align: 'left', editable: true, required: true, type: 'email' },
            { field: 'nomUsuario', headerName: 'USUARIO', width: 180, align: 'left', editable: true, required: true },
            { field: 'contraseña', headerName: 'CONTRASEÑA', width: 120, align: 'left', editable: true, required: true },
            //{ field: 'rol', headerName: 'ROL', width: 120, align: 'left', editable: true },
            {
                field: 'rol',
                headerName: 'ROL',
                width: 140,
                editable: true,
                type: 'singleSelect',
                valueOptions: rowsRol.map((rol) => ({
                    //key: rol.rolID,
                    value: rol.nombre, // Valor que se guarda en la fila
                    label: rol.nombre, // Texto que se muestra en el desplegable
                })),
                required: true
            },
            { field: 'activo', headerName: 'ACTIVO', width: 80, align: 'center', editable: true, type: 'boolean' }];//,
        })()

        setColumns(columnData);
    }, [rowsRol])

    const handleCreateUsuario = async (newRow) => {
        try {
            const response = await dataService.insertarUsuario(newRow)
            setRows([...rows, response]);
            return response;
        } catch (err) {
            setError('Error al crear el registro');
            setMostrarmostrarError(true);
            console.error(err);
            throw err;
        }
    };

    const handleUpdateUsuario = async (updatedRow) => {
        try {
            const response = await dataService.actualizarUsuario(updatedRow.usuarioID, updatedRow)
            setRows(rows.map((row) => (row.id === updatedRow.id ? response : row)));
            return response;
        } catch (err) {
            setError('Error al actualizar el registro');
            setMostrarmostrarError(true);
            console.error(err);
            throw err;
        }
    };

    const handleDeleteUsuario = async (id) => {
        try {
            await api.delete(`/users/${id}`);
            setRows(rows.filter((row) => row.id !== id));
        } catch (err) {
            setError('Error al eliminar el registro');
            setMostrarmostrarError(true);
            console.error(err);
            throw err;
        }
    };

    return (
        <>
            {!mostrarError ? "" : <CustomDialog message={error} btnText="OK" title="Aviso" state={setMostrarmostrarError} open={mostrarError} />}
            <CssBaseline />
            <NavAppBar />
            <Container style={{ maxWidth: 1360 }} >
                <Box display="flex" justifyContent="center" margin="dense">
                    <h2>Usuarios</h2>
                </Box>
                {rows && rows.length > 0 ? (
                    <>
                        <Grid className="contenedor" container spacing={0} maxWidth="500">
                            <DynamicDataGrid
                                showAddInfo={true}
                                rows={rows}
                                columns={columns}
                                onCreate={handleCreateUsuario}
                                onUpdate={handleUpdateUsuario}
                                onDelete={handleDeleteUsuario}
                            />
                        </Grid>
                        <br />
                    </>
                ) : ""}
            </Container>
        </>
    );
}